(function() { window.GUID_99b66fee_c0ae_46d1_863b_aa846f06e783 = { getGuid: function() { return "99b66fee-c0ae-46d1-863b-aa846f06e783"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let OpponentType;
        (function (OpponentType) {
            OpponentType[OpponentType["Single"] = 0] = "Single";
            OpponentType[OpponentType["Double"] = 1] = "Double";
            OpponentType[OpponentType["Triple"] = 2] = "Triple";
            OpponentType[OpponentType["Team"] = 4] = "Team";
        })(OpponentType = Enumeration.OpponentType || (Enumeration.OpponentType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OpponentType.pre.js.map
